export function getPageConfig(id = 'page-config') {
    const el = document.getElementById(id);
    if (!el) return {};
    try {
        return JSON.parse(el.textContent);
    } catch {
        console.error('Failed to parse page config');
        return {};
    }
}